module.exports = __webpack_public_path__ + "static/media/close-modal.6c643aaf.svg";